import React from "react";
import styled from "@emotion/styled";
import { Chip as MuiChip } from "@mui/material";
import {
  HIGH_CONFIDENCE_SCORE,
  MEDIUM_CONFIDENCE_SCORE,
  VERY_HIGH_CONFIDENCE_SCORE,
} from "../../utils/constants";

const Chip = styled(MuiChip)<{ color?: string }>`
  height: 23px;
  font-size: 11px;
  background-color: ${(props) =>
    props.theme.palette[props.color ? props.color : "primary"].light};
  color: ${(props) => props.theme.palette.common.white};
`;

interface Prop {
  score: number;
}

function ConfidenceChip(prop: Prop) {
  const { score } = prop;

  if (score >= VERY_HIGH_CONFIDENCE_SCORE) {
    return <Chip label="Very High Confidence" color="primary" />;
  } else if (score >= HIGH_CONFIDENCE_SCORE) {
    return <Chip label="High Confidence" color="success" />;
  } else if (score >= MEDIUM_CONFIDENCE_SCORE) {
    return <Chip label="Medium Confidence" color="warning" />;
  } else {
    return <Chip label="Low Confidence" color="error" />;
  }
}

export default ConfidenceChip;
